import { render, staticRenderFns } from "./OccurrenceMapModal.vue?vue&type=template&id=1b6e8af6&scoped=true&"
import script from "./OccurrenceMapModal.vue?vue&type=script&lang=js&"
export * from "./OccurrenceMapModal.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceMapModal.vue?vue&type=style&index=0&id=1b6e8af6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6e8af6",
  null
  
)

export default component.exports